import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Color, Size } from 'const'
import { MEDIA_QUERY } from 'config/constants'

export const Pagination = ({ className, chunkIndex, setChunkIndex, max }) => {
  const nextChunkIndex = () => {
    if (chunkIndex < max) {
      setChunkIndex(chunkIndex + 1)
      /* ブラウザバックに対応するために pageIndex をpathパラメータへ保存 */
      window.location.search = `?page=${chunkIndex + 1}`
    }
  }
  const prevChunkIndex = () => {
    if (chunkIndex > 0) {
      setChunkIndex(chunkIndex - 1)
      /* ブラウザバックに対応するために pageIndex をpathパラメータへ保存 */
      window.location.search = `?page=${chunkIndex - 1}`
    }
  }
  const pageIndexArray = [...Array(max).keys()].map((i) => ++i)
  /* 5ページ以上の場合に「...」のような表記にする */
  const mutatedPageIndexView = useMemo(() => {
    if (chunkIndex === 0) return [...pageIndexArray.slice(0, 3), '...', max]
    if (chunkIndex + 1 === max) return [1, '...', ...pageIndexArray.slice(max - 3, max)]
    if (chunkIndex + 1 > max - 3) return [1, '...', ...pageIndexArray.slice(max - 3, max)]
    if (chunkIndex + 1 > max - 4) return ['...', ...pageIndexArray.slice(max - 4, max)]

    return [...pageIndexArray.slice(chunkIndex, chunkIndex + 3), '...', max]
  }, [chunkIndex, max, pageIndexArray])

  /* ページが1ページしかない場合は表示しない */
  if (max !== 1)
    return (
      <StyledPagination className={className}>
        {chunkIndex > 0 && (
          <div className="button_wrapper">
            <button className="next_button" onClick={prevChunkIndex}>
              前へ
            </button>
          </div>
        )}
        {pageIndexArray.length < 6
          ? pageIndexArray.map((pageIndex) => (
              <span key={pageIndex} className={pageIndex === chunkIndex + 1 ? 'current' : ''}>
                {pageIndex}
              </span>
            ))
          : mutatedPageIndexView.map((pageIndex) => (
              <span key={pageIndex} className={pageIndex === chunkIndex + 1 ? 'current' : ''}>
                {pageIndex}
              </span>
            ))}
        {chunkIndex + 1 < max && (
          <div className="button_wrapper">
            <button className="next_button" onClick={nextChunkIndex}>
              次へ
            </button>
          </div>
        )}
      </StyledPagination>
    )

  return null
}

const StyledPagination = styled.div`
  width: 364px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  padding-top: 12px;
  margin: 0 auto;
  font-family: '游ゴシック体', YuGothic, '游ゴシック Medium', 'Yu Gothic Medium', '游ゴシック', 'Yu Gothic',
    -apple-system, BlinkMacSystemFont, 'Hiragino Kaku Gothic ProN', 'Noto Sans JP', 'メイリオ', Meiryo, Sans-Serif;
  ${MEDIA_QUERY.SP} {
    padding-bottom: 24px;
  }
  > span {
    display: inline-block;
    width: 28px;
    text-align: center;
    font-weight: 700;
    font-size: ${Size.FONT.BIG};
    &.current {
      color: ${Color.FONT.CHERRY};
    }
  }
  > .button_wrapper {
    width: 60px;
    margin: 0 15px;
    > button {
      font-size: 12px;
      width: 60px;
      cursor: pointer;
      border-radius: 45px;
      border: solid 1px #e3e3e6;
      background-color: #fff;
      height: 34px;
      font-weight: 700;
      font-family: inherit;
    }
  }
`
